module.exports = __webpack_public_path__ + "media/src/images/icons/chevron-down-1a03f85fbc475b458967bc23e3315161.svg";